module.exports = __webpack_public_path__ + "static/media/header-network-iotex.2fb42174.svg";